module.exports = __webpack_public_path__ + "static/media/canela-light.b9bcfd17.woff2";